module.exports = __webpack_public_path__ + "static/media/empty.7c64e41d.svg";